import * as React from 'react';

import { FormattedMessage } from 'js/lib/coursera.react-intl';

import { Link, Typography2, type Typography2Props, useTheme } from '@coursera/cds-core';

import _t from 'i18n!nls/authentication';

// TODO: Move .grecaptcha-badge { visibility: hidden; } to Emotion
import 'css!bundles/authentication-common/components/botManager/__styles__/RecaptchaDisclaimer';

type Props = {
  isEnterprise?: boolean;
} & Pick<Typography2Props, 'variant' | 'color' | 'align' | 'className'>;

const RecaptchaDisclaimer = ({ isEnterprise = false, variant = 'bodySecondary', ...typographyProps }: Props) => {
  useTheme();

  const message = isEnterprise
    ? _t('This site is protected by reCAPTCHA Enterprise and the Google {privacyPolicyLink} and {tosLink} apply.')
    : _t('This site is protected by reCAPTCHA and the Google {privacyPolicyLink} and {tosLink} apply.');

  return (
    <Typography2 component="p" variant={variant} {...typographyProps}>
      <FormattedMessage
        message={message}
        privacyPolicyLink={
          <Link variant="standard" href="https://policies.google.com/privacy" target="_blank" rel="noopener noreferrer">
            {_t('Privacy Policy')}
          </Link>
        }
        tosLink={
          <Link variant="standard" href="https://policies.google.com/terms" target="_blank" rel="noopener noreferrer">
            {_t('Terms of Service')}
          </Link>
        }
      />
    </Typography2>
  );
};

export default RecaptchaDisclaimer;
